import React, { useEffect, useMemo, useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import MyTextField from '../../utils/MyTextField'

//UnoButton
import UnoButton from '../../utils/UnoButton'
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CloseIcon from '@material-ui/icons/Close';
import { unoTheme } from "../../../assets/styles/unoTheme";

import { useDispatch } from "react-redux";
import allActions from "../../../actions";

//Grid
import { Grid } from "@material-ui/core";

//API
import { FundGroupsAPI } from '../../../API/fund_groups'

import CircularProgress from '@material-ui/core/CircularProgress';

import ConfirmActionRightContent from './ConfirmActionRightContent'

import GroupArticlesWrapper from '../../utils/GroupArticlesWrapper/GroupArticlesWrapper';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
    },

    header: {
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(3)
    },

    main: {
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: theme.spacing(5),
        paddingRight: theme.spacing(5),
        paddingBottom: theme.spacing(3),
        textAlign: 'left',
    },

    hiddenIcon: {
        visibility: 'hidden',
    },
    groupFundsSection: {
        marginTop: theme.spacing(2),

        '& .sectionTitle': {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            marginBottom: theme.spacing(1),
        },

        '& .fundsList': {
            border: 'solid 1px #e0e0e0',
            borderRadius: '8px',
            maxHeight: '220px',
            overflowY: 'auto',

            '& .fundRow': {
                padding: '8px 12px',
                borderBottom: 'solid 1px #f0f0f0',
                display: 'flex',
                flexDirection: 'column',

                '&:last-child': {
                    borderBottom: 'none',
                },

                '& .fundCnpj': {
                    color: unoTheme.secondaryText || '#888',
                    fontSize: '12px',
                }
            },

            '& .emptyFunds': {
                padding: '12px',
                color: '#888',
                fontSize: '13px',
            }
        }
    },
    bottom: {

        display: 'flex',
        alignItems: 'flex-end',
        flexDirection: 'column',
        justifyContent: 'flex-end',

        '& .bottomButtons': {
            paddingTop: theme.spacing(2),
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }

    },
    rightDivBackdrop: {
        backgroundColor: 'white',
        position: 'absolute',
        opacity: 0.7,
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '& .progress': {
            color: unoTheme.mainColor
        }
    },

}));

export default function NewFundsGroup(props) {

    const classes = useStyles();
    const dispatch = useDispatch();

    const { content } = props

    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [confirmingAction, setConfirmingAction] = useState(false);

    //form
    const [submitted, setSubmitted] = useState(false);

    const [title, setTitle] = useState('');

    //Artigos do agrupamento
    const [initialArticles, setInitialArticles] = useState(null); //null = ainda carregando (edição)
    const [groupArticles, setGroupArticles] = useState([]);
    const [validatedMessages, setValidatedMessages] = useState({});

    //Preview dos fundos enquadrados nos artigos selecionados (global, enquadramento atual)
    const [groupFunds, setGroupFunds] = useState([]);
    const [loadingGroupFunds, setLoadingGroupFunds] = useState(false);

    //Chave estável do conjunto de artigos selecionados (evita refetch/loop desnecessário)
    const articleIdsKey = useMemo(() => {
        const ids = (groupArticles || []).filter(a => a.article_id).map(a => String(a.article_id));
        return Array.from(new Set(ids)).sort().join(',');
    }, [groupArticles]);

    useEffect(() => {

        let active = true;

        async function fetchGroupFunds() {

            if (!articleIdsKey) {
                setGroupFunds([]);
                return;
            }

            setLoadingGroupFunds(true);
            const response = await FundGroupsAPI.getFundsByArticleIds(articleIdsKey.split(','));
            if (!active) return;

            setLoadingGroupFunds(false);
            setGroupFunds(response.success && response.body.rows ? response.body.rows : []);
        }

        fetchGroupFunds();

        return () => { active = false; };

    }, [articleIdsKey]);

    async function loadInfos(data) {

        setTitle(data.title);

        const response = await FundGroupsAPI.getFundGroupArticles(data.id);
        if (response.success) {
            setInitialArticles(response.body.rows);
        } else {
            setInitialArticles([]);
        }
    }

    function isValidGroupArticles() {

        let isValid = true;
        const messages = {};
        const seen = {};

        (groupArticles || []).forEach((el, index) => {

            messages[index] = [];

            if (!el.article_id) {
                messages[index].push("Selecione a resolução, o segmento e o artigo");
                isValid = false;
            } else if (seen[el.article_id]) {
                messages[index].push("Artigo repetido neste agrupamento");
                isValid = false;
            } else {
                seen[el.article_id] = true;
            }
        });

        return { isValid, messages };
    }

    async function doSaveFundGroup() {

        setSubmitted(true);

        const { isValid, messages } = isValidGroupArticles();
        setValidatedMessages(messages);

        if (title == "" || !isValid) {
            return;
        }

        setOpenBackdrop(true);

        const articlesPayload = groupArticles
            .filter(a => a.article_id)
            .map(a => ({ article_id: a.article_id }));

        let response;
        if (content.update) {
            response = await FundGroupsAPI.updateFundGroup({
                id: content.data.id,
                title,
                articles: articlesPayload,
            });
        } else {
            response = await FundGroupsAPI.createFundGroup({
                title,
                articles: articlesPayload,
            });
        }

        if (response.success) {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'success',
                message: content.update ? "Agrupamento atualizado com sucesso!" : "Agrupamento cadastrado com sucesso!"
            }))

            dispatch(allActions.rightContentActions.update())

        } else {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: "Erro ao salvar o agrupamento: " + (response.body && response.body.message ? response.body.message : '')
            }))
        }

        setOpenBackdrop(false);
    }

    async function doDeleteFundGroup() {

        setOpenBackdrop(true);

        const response = await FundGroupsAPI.deleteFundGroup(content.data.id);

        if (response.success) {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'success',
                message: response.body.message
            }))

        } else {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: "Erro ao excluir o agrupamento: " + (response.body && response.body.message ? response.body.message : '')
            }))
        }

        setOpenBackdrop(false)
        dispatch(allActions.rightContentActions.update());
    }

    function handleCancel() {
        setConfirmingAction(false);
    }

    function handleConfirm() {
        doDeleteFundGroup();
    }

    useEffect(() => {

        if (content.update) {
            loadInfos(content.data);
        } else {
            setInitialArticles([]);
        }

    }, [])

    return (
        <div className={classes.root}>

            {
                !confirmingAction ?
                    <>
                        <div className={classes.header}>
                            <IconButton
                                className={classes.hiddenIcon}>
                                <ArrowBackIcon />
                            </IconButton>

                            <div>
                                <Typography
                                    variant={'h6'}
                                    align={'left'}>

                                    {content.update ? "Editar Agrupamento" : "Cadastrar Agrupamento"}

                                </Typography>
                            </div>

                            <IconButton
                                onClick={() => dispatch(allActions.rightContentActions.setRightContent(null))}>
                                <CloseIcon />
                            </IconButton>

                        </div>

                        <div className={classes.main}>
                            <Grid container spacing={2}>

                                <Grid item lg={12} md={12} sm={12} xs={12} >
                                    <MyTextField
                                        outerlabel={'Título'}
                                        value={title}
                                        onChange={(value) => setTitle(value)}
                                        validator={title == "" && submitted ? true : undefined}
                                        helperText={"É necessário informar o título"}
                                        placeholder={'Insira o título do agrupamento'} />
                                </Grid>

                                <Grid item lg={12} md={12} sm={12} xs={12} >
                                    {
                                        initialArticles != null ?
                                            <GroupArticlesWrapper
                                                initialArticles={initialArticles}
                                                articlesNodesCallback={(articles) => setGroupArticles(articles)}
                                                submitted={submitted}
                                                validatedMessages={validatedMessages} />
                                            : null
                                    }
                                </Grid>

                                <Grid item lg={12} md={12} sm={12} xs={12} >
                                    <div className={classes.groupFundsSection}>
                                        <div className={'sectionTitle'}>
                                            <Typography variant={'subtitle2'}>
                                                {'Fundos do agrupamento' + (groupFunds.length ? ' (' + groupFunds.length + ')' : '')}
                                            </Typography>
                                            {loadingGroupFunds ? <CircularProgress size={16} /> : null}
                                        </div>
                                        <div className={'fundsList'}>
                                            {
                                                groupFunds.length ?
                                                    groupFunds.map((fund) => (
                                                        <div className={'fundRow'} key={'group-fund-' + fund.id}>
                                                            <span>{fund.fund_name}</span>
                                                            <span className={'fundCnpj'}>{fund.cnpj}</span>
                                                        </div>
                                                    ))
                                                    :
                                                    <div className={'emptyFunds'}>
                                                        {loadingGroupFunds
                                                            ? 'Buscando fundos...'
                                                            : (articleIdsKey
                                                                ? 'Nenhum fundo enquadrado atualmente nos artigos selecionados'
                                                                : 'Selecione artigos para visualizar os fundos enquadrados')}
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                </Grid>

                            </Grid>

                            <br />
                            <div className={classes.bottom}>

                                <div className={'bottomButtons'}>

                                    <UnoButton
                                        className={
                                            !content.update ? classes.hiddenIcon : null}
                                        onClick={() => setConfirmingAction(true)}
                                        type='errorClean'>
                                        {"Excluir agrupamento"}
                                    </UnoButton>

                                    <UnoButton
                                        onClick={() => doSaveFundGroup()}
                                        type={content.update ? 'success' : 'primary'}>
                                        {content.update ? "Atualizar agrupamento" : "Criar agrupamento"}
                                    </UnoButton>

                                </div>

                            </div>

                        </div>
                    </>

                    :

                    <ConfirmActionRightContent
                        message={`Tem certeza que quer excluir o agrupamento ${content.data.title}?`}
                        handleCancel={handleCancel}
                        handleConfirm={handleConfirm}
                    />
            }

            {
                openBackdrop ?
                    <div className={classes.rightDivBackdrop}>
                        <CircularProgress className={'progress'} />
                    </div> : null
            }

        </div>
    );
}
